<template>
  <div class="resultsV2-style-segment">
    <div class="resultsV2-style-description">
      <span class="resultsV2-style-description-title">Quelle stratégie d’apprentissage favorisez-vous ?</span>
      <div class="resultsV2-style-description-subtitle">
        <span>
          Vous préférez apprendre par 
          <span class="resultsV2-learn-colour"> {{getStyle()}}</span>.
        </span>
      </div>
      <div class="resultsV2-style-description-text"> {{getStyleDescription()}} </div>
      <div class="resultsV2-style-keys-segment">
        <div class="resultsV2-style-keys-back resultsV2-learn-bg-colour"><span
            class="resultsV2-style-keys-text">{{getStyleKey1()}} </span></div>
        <div class="resultsV2-style-keys-back resultsV2-learn-bg-colour"><span
            class="resultsV2-style-keys-text">{{getStyleKey2()}} </span></div>
        <div class="resultsV2-style-keys-back resultsV2-learn-bg-colour"><span
            class="resultsV2-style-keys-text">{{getStyleKey3()}} </span></div>
      </div>
    </div>
    <div class="resultsV2-style-graph-area">
      <div class="resultsV2-style-box4-vertical resultsV2-style-box4-vertical-top" :class="getSelectBGClass('Repeating')">
        <span class="resultsV2-style-box4-text" :class="getSelectClass('Repeating')">
          Répétition
        </span>
      </div>
      <div class="resultsV2-style-box4-vertical" :class="getSelectBGClass('Reformulate')">
        <span class="resultsV2-style-box4-text" :class="getSelectClass('Reformulate')">
          Élaboration
        </span>
      </div>
      <div class="resultsV2-style-box4-vertical"  :class="getSelectBGClass('Organisation')">
        <span class="resultsV2-style-box4-text" :class="getSelectClass('Organisation')">
          Organisation
        </span>
      </div>
      <div class="resultsV2-style-box4-vertical resultsV2-style-box4-vertical-bottom"  :class="getSelectBGClass('Thinking')">
        <span class="resultsV2-style-box4-text" :class="getSelectClass('Thinking')">
          Pensée critique
        </span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['style'],
  methods: {
    getStyle() {
      var text = "";
      switch (this.style) {
        case 'Repeating':
        text = "la répétition";
          break;
        case 'Reformulate':
        text = "l'élaboration";
          break;
        case 'Organisation':
        text = "l'organisation";
          break;
        case 'Thinking':
        text = "la pensée critique";
          break;
        default:
          break;
      }
      return text;
    },
    getStyleDescription() {
      var text = "";
      switch (this.style) {
        case 'Repeating':
        text = "Votre approche de l'apprentissage se fonde sur une pratique méthodique et régulière, privilégiant la consolidation progressive des connaissances. Cette stratégie basée sur la répétition vous permet d'ancrer durablement les savoirs et les compétences dans votre pratique professionnelle. Vous établissez naturellement des routines d'apprentissage efficaces, créant un rythme qui favorise l'assimilation en profondeur des nouveaux concepts. Cette méthode systématique, bien que parfois perçue comme traditionnelle, démontre une remarquable efficacité dans la construction d'une expertise solide et durable.";
          break;
        case 'Reformulate':
        text = "Votre approche de l'apprentissage se caractérise par une démarche créative et constructive, où vous excellez dans l'art de tisser des liens entre différents concepts. Cette capacité à élaborer des connections pertinentes vous permet de construire une compréhension riche et nuancée des sujets abordés. Vous développez naturellement des structures de pensée complexes, assemblant les connaissances comme un artisan assemblerait les pièces d'une œuvre sophistiquée. Cette approche favorise une compréhension profonde et une capacité accrue à mobiliser vos connaissances dans différents contextes.";
          break;
        case 'Organisation':
        text = "Votre stratégie d'apprentissage se distingue par une approche hautement structurée et méthodique de l'acquisition des connaissances. Telle un architecte, vous construisez votre savoir selon un plan précis, veillant à ce que chaque nouvel élément trouve sa place dans une structure cohérente. Cette organisation méticuleuse vous permet de maintenir une vision claire de votre progression et facilite la récupération des informations quand nécessaire. Votre capacité à créer des systèmes d'apprentissage ordonnés contribue significativement à l'efficacité de votre développement professionnel.";
          break;
        case 'Thinking':
        text = "Votre approche de l'apprentissage se caractérise par une démarche analytique approfondie et un questionnement constant. Vous ne vous contentez jamais des évidences apparentes, cherchant toujours à explorer les dimensions cachées et les implications plus larges des sujets étudiés. Cette curiosité intellectuelle active s'accompagne d'une capacité à examiner les informations sous différents angles, remettant en question les présupposés et cherchant des perspectives alternatives. Cette approche réflexive enrichit considérablement la qualité et la profondeur de vos apprentissages.";
          break;
        default:
          break;
      }
      return text;
    },
    getStyleKey1() {
      var text = "";
      switch (this.style) {
        case 'Repeating':
        text = "Ancrage ";
          break;
        case 'Reformulate':
        text = "Sculpture ";
          break;
        case 'Organisation':
        text = "Architecture ";
          break;
        case 'Thinking':
        text = "Curiosité ";
          break;
        default:
          break;
      }
      return text;
    },
    getStyleKey2() {
      var text = "";
      switch (this.style) {
        case 'Repeating':
        text = "Mémorisation ";
          break;
        case 'Reformulate':
        text = "Liens ";
          break;
        case 'Organisation':
        text = "Structure ";
          break;
        case 'Thinking':
        text = "Analyse ";
          break;
        default:
          break;
      }
      return text;
    },
    getStyleKey3() {
      var text = "";
      switch (this.style) {
        case 'Repeating':
        text = "Rythme";
          break;
        case 'Reformulate':
        text = "Synthèse";
          break;
        case 'Organisation':
        text = "Ordre";
          break;
        case 'Thinking':
        text = "Questionnement";
          break;
        default:
          break;
      }
      return text;
    },
    getSelectClass(style) {
      var text = "";
      if  (this.style == style) {
        text += "resultsV2-style-box4-text-selected";
      }
      return text;
    },
    getSelectBGClass(style) {
      var text = "";
      if  (this.style == style) {
        text += "resultsV2-learn-bg-colour";
      }
      return text;
    },
  }
};
</script>

<style>
.resultsV2-learn-colour {
  color: #7AD3FF;
}

.resultsV2-learn-bg-colour {
  background: linear-gradient(180deg, #7AD3FF, #4FBAF0)!important;
}
</style>